export default "__VITE_ASSET__DJzdBl3j__"